import React, { useRef, useEffect, useState } from 'react'
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { useFormik } from 'formik';
import legalEntity from '../template/legalEntity.csv'
import customer from '../template/customer.csv'
import project from '../template/Projects.csv'
import leavetype from '../template/leaveType.csv'

const ImportPopup = ({onClose,type}) => {
    const [file,setFile] =useState();
    const formik = useFormik({
        initialValues: {
            resume: ''
        },
    });
    

    
    return (
        <Panel  >

            <div className="grid">
                <div className="col- ml-3">
                    <div className="p-fluid">
                        <div className="field">
                            <h1>Sample File Download</h1>
                        </div>
                        <div className="field">
                            <Button
                             style={{ width: "120px" }} >
                            <a style={{color:"White",
                            textDecoration: 'none'  }}

                            href={type==="Customer"?customer:
                                type==="project"?project:
                                type==="leaveType"?leavetype:
                                type==="legalEntity"?legalEntity:
                                legalEntity}
                        
                            download="Import.csv" >Download File</a>
                            </Button>
                        </div>
                        <p>click here for download csv file</p>
                    </div>
                </div>
                <div className="col-2" >
                    <Divider layout="vertical" style={{ borderLeft: "1px solid #DCDCDC", marginLeft: "50px" }}>
                    </Divider>
                </div>
                <div className="col-3  ">
                    <div className="p-fluid">
                        <div className="field">
                            <h1>Upload</h1>
                        </div>
                        <p> Select CSV file</p>
                        <div className="field">
                            <input
                                type="file"
                                accept=".Csv"
                                />

                        </div>
                    </div>
                </div>
                <hr />
            </div>
        </Panel>

)

}
export default ImportPopup